import { on } from "events";
import { Box } from "grommet";
import { ResearchDescription } from "../research-description";

export interface LeftSidebarProps {
  handleUploadSliders(upload_values: Array<number>): void;
}

export function LeftSidebar({ handleUploadSliders }: LeftSidebarProps): React.ReactElement {
  return (
    <Box gridArea="left-sidebar" gap="medium">
      <ResearchDescription handleUploadSliders={handleUploadSliders} />
    </Box>
  );
}
